import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';

import Form from 'UI/molecules/Form';

const SecondSurnameField = forwardRef((props, ref) => {
  const { t } = useTranslation('userDataCard');

  const { errors, ...other } = props;

  return (
    <Form.Field>
      <Form.Label htmlFor="form_surname2">
        {t('form.step2.surname2.label')} *
      </Form.Label>
      <Form.Control>
        <Form.Input
          error={errors.surname2}
          {...other}
          id="form_surname2"
          name="surname2"
          ref={ref}
          placeholder={t('form.step2.surname2.placeholder')}
        />
        {errors.surname2 && <Form.Error>{errors.surname2?.message}</Form.Error>}
      </Form.Control>
    </Form.Field>
  );
});

SecondSurnameField.displayName = 'SecondSurnameField';

SecondSurnameField.propTypes = {
  errors: PropTypes.object,
};

export default SecondSurnameField;
